module.exports = __webpack_public_path__ + "img/allrank.dfa8c329.png";